const rolePrefix = 'pedigree_';

export function prettifyRole(role) {
  if (role?.startsWith(rolePrefix)) {
    return role.substring(rolePrefix.length);
  }

  return role;
}
